import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUser, FiMail, FiCalendar, FiUsers } = FiIcons;

const PersonalInfo = ({ personalInfo, setPersonalInfo }) => {
  const handleChange = (field, value) => {
    setPersonalInfo(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-6"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
            <SafeIcon icon={FiUser} className="text-brand-primary" />
            Clinician Name *
          </label>
          <input
            type="text"
            value={personalInfo.clinicianName}
            onChange={(e) => handleChange('clinicianName', e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent transition-all"
            placeholder="Enter your full name"
            required
          />
        </div>

        <div className="space-y-2">
          <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
            <SafeIcon icon={FiMail} className="text-brand-primary" />
            Clinician Email *
          </label>
          <input
            type="email"
            value={personalInfo.clinicianEmail}
            onChange={(e) => handleChange('clinicianEmail', e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent transition-all"
            placeholder="your.email@example.com"
            required
          />
        </div>

        <div className="space-y-2">
          <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
            <SafeIcon icon={FiUsers} className="text-brand-secondary" />
            Team Lead Name *
          </label>
          <input
            type="text"
            value={personalInfo.teamLeadName}
            onChange={(e) => handleChange('teamLeadName', e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent transition-all"
            placeholder="Enter team lead's full name"
            required
          />
        </div>

        <div className="space-y-2">
          <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
            <SafeIcon icon={FiMail} className="text-brand-secondary" />
            Team Lead Email *
          </label>
          <input
            type="email"
            value={personalInfo.teamLeadEmail}
            onChange={(e) => handleChange('teamLeadEmail', e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent transition-all"
            placeholder="teamlead.email@example.com"
            required
          />
        </div>

        <div className="space-y-2 md:col-span-2">
          <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
            <SafeIcon icon={FiCalendar} className="text-brand-accent" />
            Assessment Date *
          </label>
          <input
            type="date"
            value={personalInfo.assessmentDate}
            onChange={(e) => handleChange('assessmentDate', e.target.value)}
            className="w-full md:w-1/2 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent transition-all"
            required
          />
        </div>
      </div>

      <div className="bg-brand-light border border-brand-secondary/30 rounded-lg p-4">
        <h3 className="font-semibold text-brand-primary mb-2">Instructions</h3>
        <p className="text-brand-primary text-sm leading-relaxed">
          Using the 0–5 Competency Scale, rate your current level for each section:
        </p>
        <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-2 text-sm text-brand-primary/80">
          <div><strong>0</strong> – Not familiar</div>
          <div><strong>1</strong> – Aware but inexperienced</div>
          <div><strong>2</strong> – Novice / learning with supervision</div>
          <div><strong>3</strong> – Entry-to-practice / practices with some support</div>
          <div><strong>4</strong> – Independent / skilled</div>
          <div><strong>5</strong> – Advanced / can teach or supervise</div>
        </div>
      </div>
    </motion.div>
  );
};

export default PersonalInfo;